export default "__VITE_ASSET__CPMH496___"